import * as React from "react";
import { connect  } from "react-redux";
import { clearField, updateProductData, updateProduct, loadProduct, deleteProduct } from "~/state/products/action";
import { RootState } from "~/state";
import { getProductById, getTemplateById, getLanguages, getGroups, getTabs } from "~/state/action";

import { Template, Product, FieldValues, Language, ProductUpdate, Group, Tab, Field } from "typings/index";
import { RouteComponentProps, Route } from "react-router";
import { Link } from "react-router-dom";
import fieldRender from "../FieldEditor";
import { isNullOrUndefined } from "util";
import { FieldContainer, ProductContainer } from "../product.style";
import Menu from "./Menu";
import { Pivot, PivotItem, Dialog, DialogFooter, PrimaryButton, DefaultButton, } from "office-ui-fabric-react";
import { getProductName } from "~/util/productHelper";

export interface Props extends RouteComponentProps<{productId: string}>
{
    
}


class ProductPage extends React.Component<Props & StateProps>
{
    language: string = "";
    componentWillMount()
    {
        this.props.loadProduct(this.props.match.params.productId);
    }

    componentWillReceiveProps(nextProps: Props & StateProps)
    {
        if (this.props.match.params.productId !== nextProps.match.params.productId)
        {
            this.props.loadProduct(nextProps.match.params.productId);
        }
    }

    renderMainProductLink = () =>
    {
        const { product } = this.props;
        if (!product || !product.parentId)
        {
            return null;
        }
        let parentName =  product.parentId;
        if (product.data && product.data.itemName && product.data.itemName.inheritedValue)
        {
            const keys = Object.keys(product.data.itemName.inheritedValue);
            if (keys.length > 0)
            {
                parentName = product.data.itemName.inheritedValue[keys[0]];
            }
        }
       
        return <div>
            <span className="product__subtitle">Main Product: <Link to={`/products/edit/${product.parentId}`}>{parentName}</Link></span> 
        </div>;
    }

    onFieldValueChange = (productId: string, key: string) => (value: FieldValues) =>
    {
        this.props.UpdateProductData(productId, { [key]: value.value });
    }

    onClearField = (productId: string, fieldName: string) => () =>
    {
       this.props.clearField(productId, fieldName);
    }



    onStatusChange = (status: number) =>
    {
        if (this.props.product)
        {
            this.props.updateProduct(this.props.product.id, { status });
        }
    }

    onRemoveClick = () =>
    {
        if (this.props.product)
        {
            this.props.history.push(this.props.match.url + "/remove");
        }
    }

    onCancel = () =>
    {
        this.props.history.goBack();
    }

    
    onLanguageClick = (language: string ) =>
    {
        this.language = language;
    }

    removeDialog = () =>
    {
        return (
            <Dialog title="Remove Product" onDismiss={this.onCancel} hidden={false} minWidth={400}>
                <p>Are you certain you want to remove this product?</p>
                <DialogFooter>
                    <PrimaryButton onClick={this.onRemove} text="Remove" />
                    <DefaultButton onClick={this.onCancel} text="Cancel" />
                </DialogFooter>
            </Dialog>
        );
        
    }

    onRemove = () =>
    {
        if (this.props.product)
        {
            this.props.deleteProduct(this.props.product.id);
            this.props.history.push("/products/");
        }
    }

    renderField = (field: Field, product: Product)  =>
    ( 
        <FieldContainer className={"vb-" + field.field.fieldType.id} key={field.field.name}>
            {fieldRender(
                field, 
                product.data[field.field.name], 
                this.onFieldValueChange(product.id, field.field.name),
                this.props.languages,
                this.onClearField(product.id, field.field.name),
                !isNullOrUndefined(product.parentId)
                )}
        </FieldContainer>
    )

    renderTab = (tab: Tab, template: Template, product: Product, groups: Group[]) =>
    {
        let fields = [...template.fields];
        return (

            <PivotItem key={tab.tabName} itemIcon={tab.TabIcon} headerText={tab.tabLabel}>
                {tab.fields.map((tabField, index) =>
                {
                    const field = fields.find(x => x.field.name === tabField);
                    const group = groups.find(x => x.fields.find(y => y === tabField) !== undefined);
                    if (!field)
                    {
                        return null;
                    }
                    if (!group)
                    {
                        fields = fields.filter(x => x.field.name !== tabField);
                        return this.renderField(field, product);
                    }
                    const groupFields = fields.filter(x => group.fields.indexOf(x.field.name) > -1);
                    fields = fields.filter(x => group.fields.indexOf(x.field.name) === -1);
                    return (
                        <div key={tabField + index} className="groupedFields">
                            <label>{group.label}</label>
                            <div className={`groupedFields__content group-${group.groupName.toLowerCase()}`}>
                                {groupFields.map(x => this.renderField(x, product))}
                            </div>
                        </div>
                    );
                    
                })}
            </PivotItem>
        );
    }

    render()
    {
        const { template, product, tabs, groups } = this.props;
        if (!template || !product)
        {
            return <div>
                <h2>Product not found</h2>
            </div>;
        }
       
        return (
            <ProductContainer className={product.parentId ? "vb-variant" : "vb-product"}>
                {this.renderMainProductLink()}
                <div>    
                    <h1>
                        {getProductName(product)}  
                    </h1>
                    <Menu 
                        languages={this.props.languages}
                        product={product}
                        onStatusChange={this.onStatusChange}
                        onRemoveClick={this.onRemoveClick}
                    />
                </div>
                <br/>
                <Pivot>
                    {tabs.map(tab => this.renderTab(tab, template, product, groups))}
                </Pivot>
                <Route path={`${this.props.match.path}/remove`} render={this.removeDialog} />
            </ProductContainer>
        );
    }
}

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    const productId = ownProps.match.params.productId;
   
    const product = getProductById(state, productId);
    let result:  {template?: Template, product?: Product, languages: Language[], groups: Group[], tabs: Tab []} = 
    {
        languages: getLanguages(state),
        groups:  getGroups(state),
        tabs: getTabs(state)
    };
    if (product)
    {
      
        const template = getTemplateById(state, product.type || "allFields");
        result = {
            ...result,
            template,
            product,
        };
    }
    return result;
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    UpdateProductData: (productId: string, data:  {[key: string]: any}) => dispatch(updateProductData(productId, data)),
    clearField:  (productId: string, fieldName: string) => dispatch(clearField(productId, fieldName)),
    updateProduct: (productId: string, update: ProductUpdate) => dispatch(updateProduct(productId, update)),
    deleteProduct: (productId: string) => dispatch(deleteProduct(productId)),
    loadProduct:(productId: string) => dispatch(loadProduct(productId))
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);


// WEBPACK FOOTER //
// ./src/components/product/product/ProductPage.tsx